<template>
  <div class="gmb-attributes-preview">
    <div
      class="attribute-group"
      v-for="service in services"
      :key="service.category.id"
    >
      <div class="group-name">{{ service.category.name }}</div>

      <div
        class="group-items"
        v-for="item in service.service_types"
        :key="item.service_type_id"
      >
        <div class="attribute" :class="{ active: !deleteMode }">
          <v-icon v-if="!deleteMode">icon-check</v-icon>
          {{ item.display_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GmbServicesPreview",
  props: {
    services: {
      type: Array,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style lang="scss" scoped>
.attribute-group {
  &:not(:first-child) {
    padding-top: $spacing * 2;
  }
}

.group-name {
  @include font-size(14px);
  font-weight: 500;
  line-height: 20px;
  color: $grey-darker;
  margin-bottom: $spacing * 1.5;
  @include borderAccent($primary, 17px);
}

.attribute-subgroup {
  margin-top: $spacing;
  margin-bottom: $spacing;
  padding: $spacing * 1.5 $spacing $spacing * 0.25;
  border-radius: 12px;
  background: $attribute-group-bg-color;

  .attribute {
    margin-left: 8px;
  }
}

.subgroup-name {
  @include font-size(14px);
  line-height: 17px;
  font-weight: 500;
  color: $grey-darker;
  margin-left: $spacing;
}

.attribute {
  display: flex;
  align-items: center;
  font-weight: normal;
  @include font-size(14px);
  line-height: 17px;
  letter-spacing: -0.01em;
  color: $attribute-inactive-color;
  margin-top: $spacing;
  margin-bottom: $spacing;

  .v-icon {
    @include font-size(20px);
    margin-right: $spacing;
    color: $attribute-inactive-color;
  }

  &.active .v-icon {
    color: $attribute-active-color;
  }
}
</style>
